// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"545":"6a428b0a","665":"ee24036b","787":"4ae8f0d4"}[chunkId] + ".chunk.js";
};